const entitySettings = {
  agencies: {
    actionName: 'loadAgency',
    groupTitle: 'AGENCIES',
    key: 'agencies',
    label: 'Agency',
    labelPlural: 'Agencies',
  },
  artworkPages: {
    actionName: 'loadArtworkPage',
    endpoint: 'artwork_pages',
    groupTitle: 'ARTWORK PAGES',
    key: 'artworkPages',
    label: 'Artwork Page',
    labelPlural: 'Artwork Pages',
  },
  brands: {
    actionName: 'loadBrand',
    groupTitle: 'BRANDS',
    key: 'brands',
    label: 'Brand',
    labelPlural: 'Brands',
  },
  brandThemes: {
    actionName: 'loadBrandTheme',
    endpoint: 'brand_themes',
    groupTitle: 'BRAND THEMES',
    key: 'brandThemes',
    label: 'Brand Theme',
    labelPlural: 'Brand Themes',
  },
  campaigns: {
    actionName: 'loadCampaign',
    groupTitle: 'CAMPAIGNS',
    key: 'campaigns',
    label: 'Campaign',
    labelPlural: 'Campaigns',
  },
  providers: {
    actionName: 'loadProvider',
    groupTitle: 'PROVIDERS',
    key: 'providers',
    label: 'Provider',
    labelPlural: 'Providers',
  },
  publications: {
    actionName: 'loadPublication',
    groupTitle: 'PUBLICATIONS',
    key: 'publications',
    label: 'Publication',
    labelPlural: 'Publications',
  },
  services: {
    actionName: 'loadService',
    endpoint: 'services',
    groupTitle: 'SERVICES',
    key: 'services',
    label: 'Service',
    labelPlural: 'Services',
  },
  serviceProducts: {
    actionName: 'loadServiceProduct',
    endpoint: 'service_products',
    groupTitle: 'PRODUCTS',
    key: 'serviceProducts',
    label: 'Product',
    labelPlural: 'Products',
  },
  taskLists: {
    actionName: 'loadTaskList',
    endpoint: 'task_lists',
    groupTitle: 'TASK LISTS',
    key: 'taskLists',
    label: 'Task List',
    labelPlural: 'Task Lists',
  },
  taskListItems: {
    actionName: 'loadTaskListItem',
    endpoint: 'task_list_items',
    groupTitle: 'TASK LIST ITEMS',
    key: 'taskListItems',
    label: 'Task List Item',
    labelPlural: 'Task List Items',
  },
  taskListSections: {
    actionName: 'loadTaskListSection',
    endpoint: 'task_list_sections',
    groupTitle: 'TASK LIST SECTIONS',
    key: 'taskListSections',
    label: 'Task List Section',
    labelPlural: 'Task List Sections',
  },
  taskListTemplates: {
    actionName: 'loadTaskListTemplate',
    endpoint: 'task_list_templates',
    groupTitle: 'TASK LIST TEMPLATES',
    key: 'taskListTemplates',
    label: 'Task List Template',
    labelPlural: 'Task List Templates',
  },
  tags: {
    actionName: 'loadTags',
    endpoint: 'tags',
    groupTitle: 'TAGS',
    key: 'tags',
    label: 'Tags',
    labelPlural: 'Tags',
  },
  templateGroups: {
    actionName: 'loadTemplateGroup',
    endpoint: 'template_groups',
    groupTitle: 'TEMPLATE GROUPS',
    key: 'templateGroups',
    label: 'Template Group',
    labelPlural: 'Template Groups',
  },
  templatePages: {
    actionName: 'loadTemplatePage',
    endpoint: 'template_pages',
    groupTitle: 'TEMPLATE PAGES',
    key: 'templatePages',
    label: 'Template Page',
    labelPlural: 'Template Pages',
  },
  users: {
    actionName: 'loadUser',
    endpoint: 'users',
    groupTitle: 'USERS',
    key: 'users',
    label: 'User',
    labelPlural: 'Users',
  },
}

export default entitySettings
